import {ModalComponents} from 'constants/Modals';

import TableRowAvatar from 'features/beersManager/shared/TableRowAvatar/TableRowAvatar';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {setModalAC} from 'store/modal/modalSlice';
import {Beer} from 'typescript/models/Beer';

import {deletePubBeerACS} from '../requestAC';
import {brewerySelector, setCheckedBeerAC} from '../slice';
import './BeersListItem.scss';

interface IBeersListItemProps {
  beer: Beer;
}

const BeersListItem = ({beer}: IBeersListItemProps) => {
  const {
    id: beer_id,
    attributes: {name, beer_logo, brewery_id},
  } = beer;

  const dispatch = useSetGlobalState();

  const matchingBrewery = useGlobalState((state) => brewerySelector.selectById(state.beersManager, brewery_id));

  const {pubBeers} = useGlobalState((state) => state.beersManager);

  const listOfPubBeerIds = pubBeers.map((pubBeer) => String(pubBeer.attributes.beer_id));

  const isInPubBeerList = listOfPubBeerIds.includes(beer_id);

  const handleCheck = () => {
    dispatch(setCheckedBeerAC({id: +beer_id, name, imageUrl: beer_logo || ''}));

    if (isInPubBeerList) {
      const matchingBeer = pubBeers.find((pubBeer) => pubBeer.attributes.beer_id === +beer_id);
      if (matchingBeer) {
        dispatch(deletePubBeerACS({pubId: String(matchingBeer.attributes.pub_id), beerId: matchingBeer.id}));
      }
    } else {
      dispatch(setModalAC(ModalComponents.CHECKED_BEER_INFO));
    }
  };

  return (
    <div className="beers-list-item">
      <TableRowAvatar name={name} breweryName={matchingBrewery?.attributes.name || '/'} logo={beer_logo} />
      <div
        role="button"
        onClick={handleCheck}
        className={`beers-list-item__toggle ${
          isInPubBeerList ? 'beers-list-item__toggle--remove' : 'beers-list-item__toggle--add'
        }`}
      >
        {isInPubBeerList ? '-' : '+'}
      </div>
    </div>
  );
};

export default BeersListItem;
